import { dropdownCategory } from '../../../common/const'

export const fieldNames = {
  code: {
    // 製造/車台番号
    name: 'code',
    type: 'text',
    label: 'FORKLIFT_COMMON_CODE_LABEL',
    operator: 'ilike',
    queryName: 'code',
    maxLength: 255,
    tabIndexes: [0]
  },
  dashcamManufacturer: {
    // ドラレコメーカー
    label: 'FORKLIFT_COMMON_DASHCAMMANUFACTURER_LABEL',
    name: 'dashcamManufacturer',
    type: 'dropdown',
    selectOptions: dropdownCategory.dashcamManufacturer_Forklift,
    tabIndexes: [1]
  },
  horizontalLaserManufacturer: {
    // 水平レーザー
    label: 'FORKLIFT_COMMON_HORIZONTALLASERMANUFACTURER_LABEL',
    name: 'horizontalLaserManufacturer',
    type: 'dropdown',
    selectOptions: dropdownCategory.horizontalLaserManufacturer,
    tabIndexes: [2]
  },
  rearLightingManufacturer: {
    // 後方床面照射ライト
    label: 'FORKLIFT_COMMON_REARLIGHTINGMANUFACTURER_LABEL',
    name: 'rearLightingManufacturer',
    type: 'dropdown',
    selectOptions: dropdownCategory.rearLightingManufacturer,
    tabIndexes: [3]
  },
  sensorsManufacturer: {
    // 対人対物センサー
    label: 'FORKLIFT_COMMON_SENSORSMANUFACTURER_LABEL',
    name: 'sensorsManufacturer',
    type: 'dropdown',
    selectOptions: dropdownCategory.sensorsManufacturer,
    tabIndexes: [4]
  },
  attachment: {
    // アタッチメント
    label: 'FORKLIFT_COMMON_ATTACHMENT_LABEL',
    name: 'attachment',
    type: 'text',
    maxLength: 255,
    tabIndexes: [5]
  },
  importantNotes: {
    // 備考
    label: 'FORKLIFT_COMMON_IMPORTANTNOTES_LABEL',
    name: 'importantNotes',
    type: 'text',
    maxLength: 255,
    tabIndexes: [6]
  }
}
